const ELEVATION_0 = 'box-shadow: none';
const ELEVATION_1 = 'box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.1)';
const ELEVATION_2 =
  'box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.1), 0px 4px 8px rgba(0, 0, 0, 0.06)';
const ELEVATION_3 =
  'box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.1), 0px 4px 6px -2px rgba(0, 0, 0, 0.03), 0px 10px 15px -3px rgba(16, 16, 16, 0.1)';
const ELEVATION_4 =
  'box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.1), 0px 10px 10px -5px rgba(0, 0, 0, 0.04), 0px 20px 25px -5px rgba(0, 0, 0, 0.1)';

const INSET_SHADOW_1 =
  'box-shadow: inset 0px 2px 4px rgba(45, 54, 66, 0.07), inset 0px 1px 2px rgba(45, 54, 66, 0.07)';

export type ElevationIndex = -1 | 0 | 1 | 2 | 3 | 4;

export const ELEVATIONS = new Map<ElevationIndex, string>([
  [-1, INSET_SHADOW_1],
  [0, ELEVATION_0],
  [1, ELEVATION_1],
  [2, ELEVATION_2],
  [3, ELEVATION_3],
  [4, ELEVATION_4],
]);

/**
 * returns a box-shadow with the correct elevation, between -1 and 4. negative are inset shadows, 0 means no shadow. 1 is the default.
 *
 * example: `elevation(1)` returns `box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.1)`
 * @param level - elevation level.
 */
export const elevation = (level: ElevationIndex = 1): string => {
  return ELEVATIONS.get(level) || ELEVATIONS.get(1);
};
